import {observable, action} from 'mobx';
import _ from 'lodash';
class DeleteModal {

  @observable deleteObject = {};

  @action eventDelete = data => {
    this.deleteObject = _.assign(data);
  };

}

export default new DeleteModal();



// WEBPACK FOOTER //
// ./src/stores/DeleteModal.js